module.exports = __webpack_public_path__ + "img/detalle_portatil.d69e8188.png";